import React, { useState, createContext } from 'react'

export const SelectedAddressContext = createContext({} as any)

const SelectedAddressContextProvider = (props: any) => {
  const [selectedAddress, setSelectedAddress] = useState<number | undefined>(
    undefined
  )

  return (
    <SelectedAddressContext.Provider
      value={{
        selectedAddress: selectedAddress,
        setSelectedAddress: setSelectedAddress,
      }}
    >
      {props.children}
    </SelectedAddressContext.Provider>
  )
}

export default SelectedAddressContextProvider
